import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'
import { AZElectricity } from '@e3dc-react/icons'
import { useStatCardStyles } from './stat-card.styles'

const useStyles = makeStyles()(theme => ({
  iconBackground: {
    backgroundColor: theme.palette.chart.totalChargedBackground,
  },
  icon: {
    color: theme.palette.chart.totalGridChargedBarV1,
  },
}))

interface Props {
  energyKWh: number
}

export const TotalEnergyCard: React.VFC<Props> = ({ energyKWh }) => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useStyles()
  const { classes: statCardClasses } = useStatCardStyles()

  return (
    <Paper className={statCardClasses.card}>
      <Stack direction="row" spacing={2}>
        <Box className={cx(statCardClasses.circularContainer, classes.iconBackground)}>
          <AZElectricity fontSize="large" className={classes.icon} />
        </Box>

        <Stack justifyContent="space-between">
          <Box>
            <Typography variant="subtitle2">{t('emobility.chargingSession.totalEnergyCharged')}</Typography>
          </Box>
          <Box>
            <Typography variant="h2">{t('common.format.kwh', { value: getLocalizedNumber(energyKWh) })}</Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  )
}
